/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignIntOperation
 */
export interface AssignIntOperation {
    /**
     * 
     * @type {number}
     * @memberof AssignIntOperation
     */
    value: number;
}

/**
 * Check if a given object implements the AssignIntOperation interface.
 */
export function instanceOfAssignIntOperation(value: object): value is AssignIntOperation {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AssignIntOperationFromJSON(json: any): AssignIntOperation {
    return AssignIntOperationFromJSONTyped(json, false);
}

export function AssignIntOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignIntOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function AssignIntOperationToJSON(value?: AssignIntOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

